export default function ({ context }) {
    const devUrl = 'https://staging18.staging.gb.ru/api/v2/users'
    const prodUrl = 'https://gb.ru/api/v2/users'

    const baseUrl = context.$config.isProd ? prodUrl : devUrl

    return {
        async setUsedeskToken(token) {
            try {
                const  response = await context.$axios.post(`${baseUrl}/set_chat_token`,
                    {
                        chat_token: token,
                    })

                return response?.data

            } catch (e) {
                console.warn(e)

                return []
            }
        },

        async getUsedeskToken() {
            try {
                const  response = await context.$axios.get(`${baseUrl}/chat_token`)

                return response?.data

            } catch (e) {
                console.warn(e)

                return []
            }
        }
    }
}
